<template>
	<div>
		<div>
			<el-button type="primary" @click="open(1);" style="float: right;margin: 0px 0px 10px 0;">新建物资
			</el-button>
		</div>
		<div>
			<el-table :data="tableData"
				:header-cell-style="{ background: '#efefef', 'text-align': 'center', color: '#2D2D2D' }"
				:cell-style="{'text-align':'center'}">
				<!-- <el-table-column label="编号"></el-table-column> -->
				<el-table-column prop="name" label="物资ID"></el-table-column>
				<el-table-column prop="name" label="物资名称"></el-table-column>
				<el-table-column prop="type" label="物资类型"></el-table-column>
				<el-table-column prop="unit" label="单位"></el-table-column>
				<el-table-column label="备注">
					<template slot-scope="scope">
						{{scope.row.remark==null?'/':scope.row.remark}}
					</template>
				</el-table-column>
				<el-table-column label="图片" align="center">
					<template slot-scope="scope">
						<el-image></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="updateTime" label="新建时间" width="150px"></el-table-column>
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<el-button type="text" @click="add01 = true;list(scope.row.id)">编辑</el-button>
						<el-button type="text">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog :visible.sync="add01" width="50%">
				<div class="dtitle">
					<span v-if="id==1">编辑物资</span>
					<span v-if="id==''">新建物资</span>
				</div>
				<div class="father">
					<div class="left">
						<el-form ref="form" label-width="150px" label-position="left">
							<el-form-item label-width="80px">
								<span slot="label">
									<span>物资类型</span>
									<span style="color: red;">*</span>
								</span>
								<el-radio-group v-model="sendData.type">
									<el-radio value="1" label="订单消耗品"></el-radio>
									<el-radio value="2" label="固定物品"></el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label-width="80px">
								<span slot="label">
									<span>物资名称</span>
									<span style="color: red;">*</span>
								</span>
								<el-input v-model="sendData.name"></el-input>
							</el-form-item>
							<el-form-item label-width="80px">
								<span slot="label">
									<span>单位</span>
									<span style="color: red;">*</span>
								</span>
								<el-input v-model="sendData.unit"></el-input>
							</el-form-item>
							<el-form-item label="备注" label-width="80px">
								<el-input v-model="sendData.remark" type="textarea"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<div class="right">
						<el-form>
							<el-form-item label="图片">
								<upload  class="el-tabs-pane-upload"  ref="sss"
									style="width: 100px; height: 100px; margin-top: 10px; margin-left: 30px;" />
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div>
				</div>
				<div style="display: flex;justify-content:center;">
					<el-button size="small" @click="add01 = false">取 消</el-button>
					<el-button size="small" type="primary" @click="save()">确 定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import upload from "../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				add01: false,
				tableData: [],
				select: '',
				id: '',
				sendData: [{
					name: '',
					type: "",
					total: 0,
					num: 0,
					unit: '',
					price: '',
					remark: ' '
				}],
			};
		},
		mounted() {
			this.list()
		},
		methods: {
			save() {
				var s = this.sendData
				console.log(s)
				if (s.name == "" || s.name == undefined) {
					this.$message.error("名称不能为空！");
					return
				}
				if (s.type == "" || s.type == undefined) {
					this.$message.error("请选择类型！");
					return
				}
				if (s.unit == "" || s.unit == undefined) {
					this.$message.error("单位不能为空！");
					return
				}
				var send2 = ""
				if (this.id != '' && this.id != undefined && this.id != null) {
					send2 = send2 + "?id=" + this.id
				} else {
					send2 = send2 + "?name=" + this.sendData.name + "&type=" + this.sendData.type + "&unit=" + this
						.sendData.unit
				}
				if (s.remark) {
					send2 = send2 + "&remark=" + this.sendData.remark
				}
				if (s.picture) {
					send2 = send2 + "&picture=" + this.sendData.picture
				}
				this.$http.get("material/saveMaterial" + send2).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.add01 = false;
						this.list()
						this.id = ''
					}
				})
			},
			list(id) {
				var a = ""
				if (id != null) {
					a = "?id=" + id
					this.id = id
				}
				this.$http.get("material/listM" + a).then(res => {
					var b = res.body.data
					if (res.body.code == 200) {
						if (id != null) {
							this.sendData = b[0]
						} else {
							this.tableData = res.body.data
						}
					}
				})
			},
			open(id) {
				if (id == 1) {
					this.sendData = []
				}
				this.add01 = true
			}
		}
	}
</script>

<style lang="less" scoped>
	.dtitle {
		font-family: SourceHanSansCN-Bold;
		font-size: 20px;
		margin: 0px 0 20px 0;
	}

	.father {
		display: flex;
	}

	.left {
		/* background-color: #0000CC; */
		width: 60%;
	}

	.right {
		/* background-color: #008200; */
		width: 40%;
		height: auto;
		float: right;
		margin-left: 10%;
	}
</style>